export default __webpack_public_path__ + "static/media/icon-truck.06ae793f.svg";